import type React from "react";
import Layout from "../../../../components/site/Layout/Layout";
import MainVisual from "./components/MainVisual/MainVisual";
import Features from "./components/Features/Features";
import LearningThemes from "./components/LearningThemes/LearningThemes";
import RecommendedFor from "./components/RecommendedFor/RecommendedFor";
import Flow from "./components/Flow/Flow";
import EventTime from "./components/EventTime/EventTime";
import Schedule from "./components/Schedule/Schedule";
import FAQ from "./components/FAQ/FAQ";
import EventReport from "./components/EventReport/EventReport";

const MokumokuTopPage: React.FC = () => {
	return (
		<Layout>
			<div className="w-full max-w-7xl mx-auto px-4 py-8 md:py-16">
				<MainVisual />
				<Features />
				<LearningThemes />
				<RecommendedFor />
				<Flow />
				<div className="bg-gray-100 py-12 rounded-lg">
					<div className="container mx-auto">
						<div className="lg:flex lg:flex-row">
							<EventTime />
							<Schedule />
						</div>
						<p className="text-center mt-4">
							詳しい開催情報は
							<a
								href="/mokumoku/schedule"
								className="text-blue-500 hover:underline"
							>
								もくもく会スケジュールページ
							</a>
							をご覧ください。
						</p>
					</div>
				</div>
				<FAQ />
				<EventReport />
			</div>
		</Layout>
	);
};

export default MokumokuTopPage;
